import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { Activity } from '../../core/dto/activity.dtos';
import Swiper from 'swiper';
import { LanguageService } from '../../core/services/language.service';

@Component({
  selector: 'app-huge-product-carousel',
  templateUrl: './huge-product-carousel.component.html',
  styleUrls: ['./huge-product-carousel.component.scss']
})
export class HugeProductCarouselComponent {
  @Input() products!: Activity[]
  readonly fallbackImage = 'assets/imgs/blog-cards/blog_new/default.webp';

  @ViewChild('swiperContainer', { static: false }) swiperContainer!: ElementRef<{ swiper: Swiper }>;

  onPrev() {
    this.swiperContainer.nativeElement.swiper.slidePrev();
  }
  onNext() {
    this.swiperContainer.nativeElement.swiper.slideNext();
  }

  trackByFn(index: number): number {
    return index
  }

  constructor(private langService: LanguageService) {}

  linkFor(p: Activity): any[] {
    if (!p?.id || !p?.title) {
      return ['/home', this.langService.lang];
    }
    return this.langService.buildProductRoute(p.id, p.title);
  }

  backgroundImageFor(p: Activity): string {
    const candidate = p?.keyPhoto?.originalUrl;
    const image = candidate && candidate.trim() ? candidate : this.fallbackImage;
    return `url(${image})`;
  }
}
